import { Candlestick } from './../components/candlestick/candlestick.component';
import { interval, take } from 'rxjs';
import { Component, Injector, OnInit, HostListener, inject, viewChild } from '@angular/core';
import {  //JkautocompleteAsyncComponent,
  JkautocompleteComponent, JkComboboxComponent,
} from 'jk-service';

import { JkgridwinComponent, JkmultiselectComponent, JkrangeComponent, } from 'jk-advcom';

import {
  jkRestReturn,
  jkLib,
  jkAlert,
  jkRestReturnClass,
} from 'jk-service';
import {
  StklgRange,
  StklgService,
  stklg002List,
  stockRangeList,
} from '../services/stklg.service';
//import { ScreenCaptureService } from '../../services/screen-capture.service';
import { JkbbchartComponent } from '../components/jkbbchart/jkbbchart.component';

import { AsyncPipe } from '@angular/common';
/*import {
  trigger,
  state,
  style,
  animate,
  transition,
} from '@angular/animations';*/
import { MaterialModule } from 'jk-service';
import { StkmaEditComponent } from '../stkma-edit/stkma-edit.component';
import { MatDialogConfig } from '@angular/material/dialog';
import { stockQuoteColDefs001, StockService } from '../services/stock.service';
import { Stkpi01Component } from '../stkpi01/stkpi01.component';
//import { Stkpi01DetailComponent } from '../stkpi01-detail/stkpi01-detail.component';
//import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
//import { MatFormFieldModule } from '@angular/material/form-field';
import { AngularSplitModule } from 'angular-split';
import {
  ColDef,
  RowDoubleClickedEvent,
  RowSelectedEvent,
} from 'ag-grid-community';
import { StockView03Component } from '../stock-view03/stock-view03.component';
import { KdChartComponent } from '../components/kd-chart/kd-chart.component';
import { MacdChartComponent } from '../components/macd-chart/macd-chart.component';
import { VolumeChartComponent } from '../components/volume-chart/volume-chart.component';
import { StkmeService } from '../services/stkme.service';
import { Stkpi20Component } from '../stkpi20/stkpi20Pkg.component';
import { ViewMarketComponent } from '../view-market/view-market.component';
import { CandlestickComponent } from '../components/candlestick/candlestick.component';
import { OrderStockComponent } from '../order-stock/order-stock.component';
import { FutureStockComponent } from '../components/future-stock/future-stock.component';
import { jkQueryComponent } from 'jk-advcom';
import { StkleService, StkmaService, StkmfService, StktmService } from '../_service_stk';
import { JackBaseComponentModule } from 'jk-service';
import { StockView02Component } from '../stock-view02/stock-view02.component';
import { Stkpi19Component } from '../stkpi19/stkpi19.component';
import { Stkpi13Component } from '../stkpi13/stkpi13Pkg.component';
import { StockQuote } from '../services/stockBase';
// 此頁選項 與參數

@Component({
  standalone: true,
  selector: 'app-stock',
  templateUrl: './stock.component.html',
  styleUrl: './stock.component.scss',
  imports: [
    MaterialModule,
    JkgridwinComponent,
    JkrangeComponent,
    StockView02Component,
    Stkpi01Component,
    Stkpi19Component,
    Stkpi13Component,
    JackBaseComponentModule,
    Stkpi20Component,
    AngularSplitModule,
    StockView03Component,
    JkbbchartComponent,
    ViewMarketComponent,
    OrderStockComponent,
    FutureStockComponent,
    JkautocompleteComponent
],
})
export class StockPage extends jkQueryComponent implements OnInit {
  stkmeSrv = inject(StkmeService);
  stkmaSrv = inject(StkmaService);
  stkmfSrv = inject(StkmfService);
  stkleSrv = inject(StkleService);

  override _programId = 'stock'; //###
  //override masterGrid!: StockQuoteComponent;
  readonly bbchart = viewChild.required<JkbbchartComponent>('bbchart');
  readonly stklg001 = viewChild.required<JkrangeComponent>('stklg001');
  stklg002Com!: JkComboboxComponent;
  stklg004Com!: JkautocompleteComponent;
  readonly stkme001 = viewChild.required<JkautocompleteComponent>('stkme001');
  readonly stkma019 = viewChild.required<JkmultiselectComponent>('stkma019');
  readonly stkpi01 = viewChild.required<Stkpi01Component>('stkpi01Com');
  readonly stkpi19 = viewChild.required<Stkpi19Component>('stkpi19Com');
  readonly stkpi13 = viewChild.required<Stkpi13Component>('stkpi13Com');
  readonly stkpi20 = viewChild.required<Stkpi20Component>('stkpi20Com');
  readonly candlestick = viewChild.required<CandlestickComponent>('candlestick');
  stkmfGrid!: JkgridwinComponent;
  stkmmGrid!: JkgridwinComponent;
  stkleGrid!: JkgridwinComponent;
  stkwlGrid!: JkgridwinComponent;
  stktbGrid!: JkgridwinComponent; // 交易明細
  stklgGrid!: JkgridwinComponent;
  stktmGrid!: JkgridwinComponent;
  stkliGrid!: JkgridwinComponent;
  //pageOpt: PageOption; //###
  //filterOpt: FilterOption; //###
  barGroupWidth: number = 400;
  //public context: CanvasRenderingContext2D;
  //dsStock: StockShow[] = [];
  open: string = 'open';
  high: string = 'high';
  low: string = 'low';
  close: string = 'close';
  UBT: string = 'UBT';
  LBT: string = 'LBT';
  X: string = 'datetime1';
  sma5: string = 'sma5';
  sma20: string = 'sma20';
  sma60: string = 'sma60';
  qty: string = 'qty';

  //tickInterval: number = 50;
  visualRange: any = {};
  scrollbarVisible: boolean = true;
  chartTitle: string = '未設定';
  //stkmaData: string = '未設定';
  //stktmData: string = '未設定';
  voiceIndex: number = 0;
  get lg004(): string {
    if (!this.stklg004Com) return '';
    return this.stklg004Com.value;
  }
  set lg004(value: string) {
    if (!this.stklg004Com) return;
    this.stklg004Com.value = value;
  }
  get lg002(): string {
    if (!this.stklg002Com) return '';
    return this.stklg002Com.value;
  }
  set lg002(value: string) {
    if (!this.stklg002Com) return;
    this.stklg002Com.value = value;
  }
  stklgSrv: StklgService = new StklgService();
  stktmSrv: StktmService = new StktmService(); //<Stktm>
  //stkmaSrv = new StkmaService();
  public stockSrv: StockService = new StockService();
  //_stockNo:string = '';
  get stockNo(): string {
    if (this.stockSrv) return this.stockSrv.stockNo;
    else return '';
  }
  set stockNo(value: string) {
    if (this.stockSrv) {
      this.stockSrv.stockNo = value;
      this.changeStockById(value);
    }
  }
  get groupNo(): string {
    if (this.stockSrv) return this.stockSrv.stkme001;
    else return '';
  }
  set groupNo(value: string) {
    if (this.stockSrv) {
      this.stockSrv.stkme001 = value;
      this.doQuery(); //MainTable=''STOCKQUOTE'' AND ITEM=''002'' '
      const stkpi13 = this.stkpi13();
      if (stkpi13) {
        let where = ` AND ME001='${value}'`;
        stkpi13.directQuery(where, '');
      }
    }
  }
  stockRangeList = stockRangeList;
  constructor() {
    super();
    /*this.gridStyle = {
      width: '100%',
      height: '500px',
      flex: '1 1 auto',
    };*/
    this.stockSrv.cbQueryStklg = this.doQueryStklg.bind(this);
    //this.stockSrv.cbQueryStkmm = this.doQueryStkmm.bind(this);
    this.stockSrv.cboSetFromMessage = this.setFromMessage.bind(this);
    /*(message: string) => {
      this.pageOpt.stockMessage = message;
    };*/
    this.setFormOpt2('stock title'); //###
    //this.filterOpt = new FilterOption(this.programId); //###
    //this.pageOpt = new PageOption(this.programId + '_page'); //###

    try {
    } catch (error: any) {
      jkAlert('StockPage contructor error:' + error.message);
    }

    // this.stkmaSrv.loadIdNameList(this.stkmaSrv.idNameOpt); // ^_^ this.stkmaLookup
    // console.log('option'+this.options.length);
  }
  // autoComplete begin
  /*
  myControl = new FormControl('');
  //options: string[] = [];
  //stkmaLookup: idNameItem[] = [];
  filteredOptions!: Observable<idNameItem[]>;//Observable<string[]>;
  private _filter(value: string): idNameItem[]  {
    const filterValue = value.toLowerCase();
      return this.stkmaSrv.idNameList.filter(option => {
        let bool = (option.idName as string).toLowerCase().includes(filterValue);
        return bool;
    });
    //return this.options.filter(option => {  option.toLowerCase().includes(filterValue) });
  }
  onStockNoEnter(e:any){
    let temp = e.target.value;
    let s = jkLib.getToken(temp,'-',1);
    if(s){
      this.stockSrv.stkmf002 = s;
      let item = {id:s};
      this.changeStock(item);
    }
  } */
  // autoComplete end
  override ngOnInit() {
    super.ngOnInit();
    /*this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '')),
    );*/
  }

  override async ngAfterViewInit() {
    super.ngAfterViewInit();
    // jkAlert('StockPage ngAfterViewInit');
    this.date1 = await this.stklgSrv.getLastDay();
    setTimeout(() => {
      const bbchart = this.bbchart();
      if (bbchart) {
        this.stklg002Com = bbchart.stklg002Com();
        this.stklg004Com = bbchart.stklg004Com();
        //this.volumechart = this.bbchart.volumechart;
      }
      this.cdr.markForCheck();      // 手動觸發變更檢測以符合 zoneless 模式
    }, 100);
    this.stockSrv.init(true, this.date1);
    setTimeout(() => {
      this.lg004 = this.getQueryParam('lg004', this.stockNo);
      this.lg002 = this.getQueryParam('lg002', '日線');
      this.doQuery();
      //this.moveStock(0);
      this.cdr.markForCheck();      // 手動觸發變更檢測以符合 zoneless 模式
    }, 500);

    try {
      this.doTimer();
    } catch (error: any) {
      alert('doTimer:' + error.message);
    }

    try {
      //this.titlebar.onUser1Click = this.doScreenCapture;
      this.checkAllInit(this); // 這行要放在 ngAfterViewInit 最後  ###
      //await this.getStockQuote();
      this.onWindowResize();

      // this.marqeeFontSize(0);

      //this.drawCandleStick(); // test
    } catch (error: any) {
      alert('XXX checkAllInit:' + error.message);
    }
  }

  override onWindowResize() {
    // ###
    super.onWindowResize();
    //this.masterGridSet.popFilter.popUpWidth =
    //  window.innerWidth - this.masterGridSet.popFilter.WidthBorder;
    //this.pageOpt.setColCount(window.innerWidth);
    this.barGroupWidth = window.innerWidth - 100;
  }
  override afterGridReady($event: JkgridwinComponent) {
    super.afterGridReady($event);
  }
  afterGridReadyStkmf($event: JkgridwinComponent) {
    this.stkmfGrid = $event;
  }
  afterGridReadyStkmm($event: JkgridwinComponent) {
    this.stkmmGrid = $event;
  }
  afterGridReadyStkle($event: JkgridwinComponent) {
    this.stkleGrid = $event;
  }
  afterGridReadyStkwl($event: JkgridwinComponent) {
    this.stkwlGrid = $event;
  }
  afterGridReadyStktb($event: JkgridwinComponent) {
    this.stktbGrid = $event;
  }
  afterGridReadyStklg($event: JkgridwinComponent) {
    this.stklgGrid = $event;
  }
  afterGridReadyStktm($event: JkgridwinComponent) {
    this.stktmGrid = $event;
  }
  afterGridReadyStkli($event: JkgridwinComponent) {
    this.stkliGrid = $event;
  }
  override agRowClicked($event: any) {
    super.agRowClicked($event);
    //let cellText = $event.target.textContent;
    /* 改用 agRowDoubleClicked
    if(!$event.data) return;
    this.changeStock($event.data);
    */
  }
  override onRowSelected($event: RowSelectedEvent<any, any>) {
    super.onRowSelected($event);
    // 會跑兩次. 一次是選取, 一次是取消選取
    this.changeStock($event.data);
  }
  changeStockById(id: string) {
    this.stkmaSrv.gotoKey(id);
    this.changeStock(this.stkmaSrv.item);
  }
  changeStock(item: any) {
    this.stockSrv.stockNo = item.id;
    this.stkmaSrv.gotoKey(this.stockNo);
    this.doQueryStklg('');


    this.doQueryStkmm(this.stockNo);
    this.doQueryStkle(this.stockNo);
    this.doQueryStkwl(this.stockNo);
    this.doQueryStktb(this.stockNo);
    this.doQueryStkli(this.stockNo);
    const stkpi01 = this.stkpi01();
    if (stkpi01) {
      let where = ` AND MA001='${this.stockNo}'`;
      stkpi01.directQuery(where, '');
    }
    const stkpi19 = this.stkpi19();
    if (stkpi19) {
      let where = ` AND TM002='${this.stockNo}'`;
      stkpi19.directQuery(where, '');
    }
    const stkpi20 = this.stkpi20();
    if (stkpi20) {
      let where = ` AND LE003='${this.stockNo}'`;
      stkpi20.directQuery(where, '');
    }
  }
  async doQueryStklg(message: string) {
    let jsonObj = undefined;
    if (message.substring(0, 1) === '{') {
      jsonObj = JSON.parse(message);
    }
    let r: StklgRange = {
      rangeId: this.stockSrv.stockRange,
      stockNos: this.stockSrv.stockNo,
      date1: this.stockSrv.date1,
      date2: this.stockSrv.date2,
      time1: '',
      time2: jkLib.nowTime4(),
      period: this.stockSrv.stklg002,
      topN: 0,
    };
    await this.stklgSrv.calcStklgRange(r);
    let where = ''; // this.stklgSrv.sqlWhereDefault;
    try {
      where = this.stklg001().addWhere(where, 'LG001');
      where = this.stklg002Com.addWhere(where, 'LG002');
      if (this.stklg004Com.value !== this.stockNo)
        this.stklg004Com.value = this.stockNo;
      where = this.stklg004Com.addWhere(where, 'LG004');
      //where = this.stkma019.addWhere(where, 'MA019');
    } catch (error: any) {
      alert('doQuery:' + error.message);
      return;
    }
    /*this.stklgGrid.maintable = 'STKLG';
    this.stklgGrid.item = 'V02';
    this.stklgGrid.type = 'S';
    this.stklgGrid.where = where;*/
    this.stklgGrid.doQuery2('STKLG', 'V02', 'S', where);
  }
  doQueryStkmm(stockno: string) {
    let where = ` AND MM003=${jkLib.quotedStr(stockno)}`;
    /*this.stkmmGrid.maintable = 'STKMM';
    this.stkmmGrid.item = '001';
    this.stkmmGrid.type = 'S';
    this.stkmmGrid.where = where;*/
    this.stkmmGrid.doQuery2('STKMM', '001', 'S', where);
  }
  doQueryStkle(stockno: string) {
    let where = ` AND LE003=${jkLib.quotedStr(stockno)}`;
    /*this.stkleGrid.maintable = 'STKLE';
    this.stkleGrid.item = '001';
    this.stkleGrid.type = 'S';
    this.stkleGrid.where = where;*/
    this.stkleGrid.doQuery2('STKLE', '001', 'S', where);
  }
  doQueryStkwl(stockno: string) {
    let where = ` AND WL001=${jkLib.quotedStr(stockno)}`;
    this.stkwlGrid.doQuery2('STKWL', '002', 'S', where);
  }
  doQueryStktb(stockno: string) {
    let where = ` AND TB004=${jkLib.quotedStr(stockno)}`;
    /*this.stktbGrid.maintable = 'STKTB';
    this.stktbGrid.item = '001';
    this.stktbGrid.type = 'S';
    this.stktbGrid.where = where;*/
    this.stktbGrid.doQuery2('STKTB', '001', 'S', where);
  }
  doQueryStkli(stockno: string) {
    let where = ` AND LI002=${jkLib.quotedStr(stockno)}`;
    this.stkliGrid.doQuery2('STKLI', '001', 'S', where);
  }

  // ### [以上是必要的]================================
  doOk(e: any) {
    this.doQuery();
  }

  override onAfterQuery(item: any, ret: jkRestReturn) {
    super.onAfterQuery(item, ret);
    if (!item) return;
    this.stockNo = item.id;
    this.updateChart();
    if (this.stockQuoteGrid?.itemList.length > 0) {
      let data = this.stockQuoteGrid.itemList[0];
      this.changeStock(data);
    }
  }
  customizeTooltip(arg: any) {
    const d = arg.argument;
    const data = arg.point.data;
    const s = jkLib.date2Display(d, '/');
    const ret =
      '日期: ' +
      s +
      '<br/>' +
      arg.seriesName +
      ': ' +
      arg.valueText +
      '<br/>' +
      '開盤: ' +
      data.open +
      '<br/>' +
      '收盤: ' +
      data.close +
      '<br/>' +
      '最高: ' +
      data.high +
      '<br/>' +
      '最低: ' +
      data.low +
      '<br/>' +
      '上軌: ' +
      data.UBT +
      '<br/>' +
      '下軌: ' +
      data.LBT +
      '<br/>' +
      'sma20: ' +
      data.sma20 +
      '<br/>' +
      'sma60: ' +
      data.sma60 +
      '<br/>';
    return {
      text: ret,
    };
  }

  myMessage(msg: string) {
    this.stockSrv.stockMessage = msg;
    //this.marquee.message1 = msg;

    //this.logMessage = jkLib.nowTime8() + ' ' + msg + '\n' + this.logMessage;
    this.logMessage =
      '<div>' + this.nowTime8() + '</div> ' + msg + '<br>' + this.logMessage;
  }

  // speechTTS(message: string) {
  //   //const ret = new jkRestReturnClass();
  //   if (!message) return;
  //   if (message === '') return;
  //   //console.log('speechTTS message:' + message);
  //   this.az.speechTTS(message, this.ret);
  //   //this.az.azure_pubpublish(pubsub_opt,message);
  //   if (this.ret.result) {
  //     this.myMessage(this.ret.getResult());
  //   }
  //   this.myMessage(message);
  // }
  /*
  async myBeep(count: number) {
    //audio.preload('pristine.mp3');
    //console.log('myBeep:',delaySec);
    for (let i = 0; i < count; i++) {
      const audio = new AudioService('pristine.mp3');
      audio.play();
      //await delay(delaySec*1000);
      //audio.player.pos(0);
    }
  }
  async myWebSpeech(isMusic: boolean, message: string) {
    if (!message) return;
    if (message === '') return;
    //console.log('myWebSpeech message:' + message);
    //this.az.speechTTS(message, this.ret);
    if (isMusic) {
      await this.myBeep(1);
      await delay(1000);
    }

    this.webSpeech.speakText(message, this.voiceIndex, 1);
    //this.az.azure_pubpublish(pubsub_opt,message);

    this.myMessage(message);
  }
*/
  /*
  azSubscript(data: string) {
    //this.speechTTS(data);
    this.myWebSpeech(true, data);
    alert(data);
  }
  */
  //async connectStockQuote() {}
  parseStock(data: string) { }
  doTest() { }
  doTimer() {
    const timer1 = interval(1000);
    const result = timer1
      .pipe
      //takeUntil(timer(startOfNextMinute))
      ()
      .subscribe((e) => {
        const now = new Date();
        let hh = now.getHours();
        let mm = now.getMinutes();
        let ss = now.getSeconds();
        //this.do5MinuteBeep(hh,mm,ss);
        this.doCheck(this.nowTime8());
      });
  }
  async doCheck(myTime: string) { }
  /*moveStock(step: number) {
    let item = this.stockSrv.moveStock(step);
    this.changeStock(item);
  }*/
  /*doScreenCapture() {
    parent.capture.screenCapture('bbchart', this.nowTime8() + '_bbchart.png'); // FIXME:
  }*/

  async doCalcOneday() {
    // let stockNos = this.objectArray2String(
    //   'TM002',
    //   this.stktm.itemList,
    //   ''
    // ); // this.stockSrv.stkmfList.map((item) => item.id);
    this.stklgSrv.doCalcOneday(
      this.stockNo,
      this.stockSrv.date1,
      this.stockSrv.date2,
      this.stockSrv.stklg002,
      this.stockSrv.topN,
      this.ret
    );
  }

  dostkmeImportStkmj() {
    // http://localhost:9086/stock/stkmeImportStkmj?date=20240903
    this.stkmeSrv.importStkmj(this.date1, this.ret);
  }
  async doCalcRange() {
    // let stockNos = this.objectArray2String(
    //   'TM002',
    //   this.stktm.itemList,
    //   ''
    // );

    this.stklgSrv.doCalcRange(
      this.stockNo,
      this.stockSrv.date2,
      this.stockSrv.stklg002,
      this.stockSrv.topN,
      '0000',
      this.ret
    );
  }
  /*
  async loadOpenwin() {
    try {
      await this.stockSrv.loadOpenwin();
    } catch (error: any) {
      alert('loadOpenwin:' + error.message);
    }
  }*/
  setFromMessage(message: string) {
    try {
      if (message.substring(0, 1) === '{') {
        let m = JSON.parse(message);
        this.lg002 = m['LG002'];
        if (m['LG002'] !== this.stockNo) this.stockNo = m['LG004'];
        this.stklg002Com.value = m['LG002'];
        this.stklg004Com.value = m['LG004'];
      } else {
        //console.log('WS setFromMessage:',message);
      }
    } catch (error: any) {
      alert('setFromMessage:' + error.message);
    }
  }
  async doQueryStktm() {
    //throw new Error('Method not implemented.');
    let where = ''; //= this.stktm.sqlWhereDefault; // this.stklgSrv.sqlWhereDefault;
    try {
      this.stktmSrv.sqlOrder = this.stktmSrv.sqlOrderDefault;
      //where = this.stkme001.addWhere(where, 'ME001');
      //where = this.stklg002.addWhere(where, 'LG002');
      //where = this.stklg004.addWhere(where, 'LG004');
      where = this.stkma019().addWhere(where, 'MA019');
      if (this.stockSrv.stktmHaveSet) {
        where =
          where +
          ` AND (TM110 <> 0 OR TM111 <> 0 OR TM112 <> 0 OR TM113 <> 0
        OR TM114 <> 0 OR TM115 <> 0 OR TM116 <> 0 OR TM117 <> 0)
        `;
      }
    } catch (error: any) {
      alert('doQueryStktm:' + error.message);
      return;
    }

    this.stktmGrid.keyExpr = ['TM002'];
    this.stktmGrid.doQuery2(
      'STKTM',
      'V03',
      'S',
      where,
      this.stktmSrv.sqlOrderDefault
    );
  }
  override async doQuery() {
    if (!this.stockQuoteGrid) return;
    await this.beforeQuery();
    this.masterTabGroupIndex = 0;
  }
  override async beforeQuery(): Promise<boolean> {
    this.where = ``; //` AND MM003=${jkLib.quotedStr(this.date1)}`;

    this.where = this.stkme001().addWhere(this.where, 'MF001');
    this.where = this.where + ` AND LG001=${jkLib.quotedStr(this.date1)}`;
    if (this.stockSrv.isSTKTM) {
      this.where = this.stktmSrv.whereIn(this.where, 'MF002');
    }

    this.stockQuoteGrid.doQuery2(
      'STOCKQUOTE',
      this.quoteMainItemValue,
      'S',
      this.where,
      '',
      this.quoteParam
    );

    //}

    return true;
  }
  candlestickList: Candlestick[] = [];
  afterQueryStklg($event: any) {
    //this.stklgGrid.resort();
    this.stklgSrv.setItemList(this.stklgGrid.itemList);
    let e = this.stklgSrv.itemList()[0];
    if (e) {
      this.candlestickList = [new Candlestick(e.open, e.high, e.low, e.close)];
      const candlestick = this.candlestick();
      if (candlestick) {
        let data = new Candlestick(e.open, e.high, e.low, e.close);
        candlestick.itemList = [data];
      }
    }
    this.updateChart();
  }
  updateChart() {
    /*
    if (this.stklgSrv.itemList.length > 0) {
      this.bbchart.stockData.importStklgV02(
        this.stklgSrv.itemList[this.stklgSrv.itemList.length - 1]
      );
      this.kdchart.itemList = this.stklgSrv.itemList;
      this.kdchart.refresh();
      this.macdchart.itemList = this.stklgSrv.itemList;
      this.macdchart.refresh();
      this.volumechart.itemList = this.stklgSrv.itemList;
      this.volumechart.setChartOptions();
    }*/
  }
  async doStkmaEdit() {
    if (!this.stkmaSrv.item || !this.stkmaSrv.item.MA001) {
      await this.showAlert('請選擇股票');
      return;
    }
    this.stkmaSrv.doEdit(); // ###

    this.dialog
      .open(StkmaEditComponent, this.initConfigSrv(this.stkmaSrv)) //###
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          //console.log('result:', result);
        }
      });
  }
  initConfigSrv(
    srv: any,
    disableClose: boolean = true,
    height: string = '90%',
    width: string = '95%',
    dialogClass: string = 'mat-dialog-container'
  ): MatDialogConfig {
    let dialRet: jkRestReturn = new jkRestReturnClass();
    dialRet.obj = srv;
    let dialConf: MatDialogConfig = {
      data: dialRet,
      hasBackdrop: true,

      //maxHeight: '90vh',
      //maxWidth: '90vw',
      height: height,
      width: width,
      disableClose: disableClose,
      panelClass: dialogClass, // 預設就會顯示不出來!
    };
    return dialConf;
  }

  // ...

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === 'PageUp') {
      //this.moveStock(-1);
      this.stockQuoteGrid?.onNextRow();
    }
    if (event.key === 'PageDown') {
      //this.moveStock(1);
      this.stockQuoteGrid?.onPreviousRow();
    }
  }
  date1: string = jkLib.nowDate();
  stockQuoteGrid!: JkgridwinComponent; //StockQuoteComponent;
  stockQuoteList: StockQuote[] = [];
  rowChange(data: any) {
    this.changeStock(data);
  }
  afterGridReadyStockQuote($event: JkgridwinComponent) {
    this.stockQuoteGrid = $event;
    this.stockQuoteGrid.onFocusedRowChanged = this.rowChange.bind(this); //agRowDoubleClicked.bind(this);
  }
  quoteMainItemValue: string = '002';
  stockQuoteAfterQuery(list: any) {
    if (list && list.length > 0) {
      if (this.stockNo !== list[0].id) this.stockNo = list[0].id;
    }
  }

  quoteParam: any[] = [];
  async doStockQuery() {
    let where = ``; //` AND MM003=${jkLib.quotedStr(this.date1)}`;

    this.stkme001().addWhere(where, 'ME001');

    where = where + ` AND LG001=${jkLib.quotedStr(this.date1)}`;

    this.stockQuoteGrid.doQuery2(
      'STOCKQUOTE',
      '002',
      'S',
      where,
      '',
      this.quoteParam
    ); // this.quoteMainItemValue
  }
  override agRowDoubleClicked($event: RowDoubleClickedEvent<any, any>) {
    super.agRowDoubleClicked($event);
    this.changeStock({ id: $event.data.id });
  }
  async doAddGroup(groupno: string, stockno: string) {
    // TODO:
    let bool = await this.confirm(this.stockNo, '確定要加入群組?');
    if (bool)
      if (!(await this.stkmfSrv.doAddGroup(groupno, stockno))) {
        await this.showToast(this.stockNo + '加入失敗');
      } else {
        this.showToast(this.stockNo + '加入成功');
      }
  }
  async doDeleteStkle() {
    let ret = await this.stkleSrv.deleteStock(this.nowDate(), this.stockNo);
    if (ret.result) {
      this.showToast('刪除成功');
    } else {
      this.showToast('刪除失敗:' + ret.message);
    }
  }
  afterColumnDefs($event: ColDef[]) {
    // 股票報價欄位設定
    let quoteCols = stockQuoteColDefs001;
    for (let i = 0; i < $event.length; i++) {
      let field = $event[i].field;
      let col = quoteCols.find((item) => item.field === field);
      if (col) {
        /*width: 72,
        cellDataType: 'number',
        cellRenderer: AgStockQuoteCellView,*/
        $event[i].headerName = col.headerName;
        $event[i].width = col.width;
        $event[i].cellDataType = col.cellDataType;
        if (col.cellRenderer) $event[i].cellRenderer = col.cellRenderer;
      }
    }
  }
}
